<div>
  <mat-label>鶏舎担当者追加・修正</mat-label>
</div><br>
<form #form="ngForm">
  <mat-form-field class="input-margin">
    <mat-label>
      担当者
    </mat-label>
    <input matInput required placeholder="担当者"
           name="name" [(ngModel)]="meisai.name">
  </mat-form-field>
</form>
<div mat-dialog-actions align="end">
  <button mat-button mat-flat-button color="primary"
          (click)="commonService.onClick(this.matDialogRef, meisai)"
          [disabled]="form.invalid || !form.dirty">
    <span>Enter</span>
  </button>
</div>
